import React, {Component} from 'react';

class ModalView extends Component {

	constructor(props) {
	  super(props);
		this.state = {
			isModalVisible:false
		}
	}

	static getDerivedStateFromProps (props,state) {
		if(props.isModalVisible !== state.isModalVisible){
		    return {
		    	isModalVisible: props.isModalVisible
		    }
		}
		return null
	}

	render() {
		console.log('Rendering: ModalWindow');
		const {isModalVisible} = this.state;
		return (
			<div className={`modal ${isModalVisible ? "is-active" : " "}`} onClick={this.props.renderModal}>
				<div className="modal-background"/>
				<div className="modal-content">
					<p className='loading-headline'>Loading...</p>
					<iframe id='iframe' title='hi' width="300" height="250" src={this.props.url}/>
				</div>
				<button className="modal-close is-large" aria-label="close"/>
			</div>
		);
	}
}

export default ModalView;



// WEBPACK FOOTER //
// ./src/ModalView.js